import {connect} from 'react-redux';

import {isDefined} from '../../../../../../libs/shared/core/src/helpers/typescript/typeHelpers';
import {getTeammates} from '../../../../../../libs/shared/core/src/store/data/teammates/commonTeammatesSelectors';
import {createSelector, makeMapStateToProps} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../../../store/appState';
import {makeGetVisualContactFromUid} from '../../../../../store/data/contacts/contactsSelectors';
import {SynopsisCellHeader} from './synopsisCellHeader';

interface SynopsisCellHeaderProps {
  contactUid?: string;
  teammateIds?: ReadonlyArray<number>;
  namespace: string;
}

function getContactUid(_state: AppState, props: SynopsisCellHeaderProps) {
  return props.contactUid;
}

function getNamespace(_state: AppState, props: SynopsisCellHeaderProps) {
  return props.namespace;
}

function getTeammateIds(_state: AppState, props: SynopsisCellHeaderProps) {
  return props.teammateIds ?? [];
}

function makeGetTeammates() {
  return createSelector([getTeammateIds, getTeammates], (teammateIds, teammates) =>
    teammateIds.map((id) => teammates[id]).filter(isDefined),
  );
}

const mapStateToProps = makeMapStateToProps<SynopsisCellHeaderProps>()(() => ({
  visualContact: makeGetVisualContactFromUid(getContactUid, getNamespace),
  teammates: makeGetTeammates(),
}));

export const SynopsisCellHeaderContainer = connect(mapStateToProps)(SynopsisCellHeader);
